import { NgModule } from "@angular/core";
import { AuditOrderRedirectLinkClassDirective } from "./audit-order-redirect-link.directive";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [
      AuditOrderRedirectLinkClassDirective
    ],
    imports: [
      CommonModule
    ],
    exports: [
      AuditOrderRedirectLinkClassDirective
    ]
  })
export class AuditOrderRedirectLinkClassModule {}

